import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import CommerceButton from '../ui/CommerceButton';
import Label from '../ui/Label';

export default function DropRegistrationForm({ code, notes, setNotes, submit, submitting, checking }) {
  const { t } = useTranslation('drop');
  const fieldId = `drop-notes-${code}`;
  return <form onSubmit={submit} className="space-y-4">
    <CommerceButton type="submit" availability="drop" big disabled={checking} loading={submitting || checking}
      text={submitting ? t('submitting') : checking ? t('checking') : t('submit')} />
    <details>
      <summary className="cursor-pointer py-2 text-sm font-semibold">{t('notesLabel')}</summary>
      <Label htmlFor={fieldId} className="sr-only">{t('notesLabel')}</Label>
      <textarea id={fieldId} rows={2} value={notes} maxLength={2000}
        onChange={(event) => setNotes(event.target.value)} placeholder={t('notesPlaceholder')} disabled={submitting || checking}
        className="flex w-full resize-y rounded-lg bg-krit-paper px-3 py-3 text-sm leading-relaxed placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-krit-drop disabled:cursor-not-allowed disabled:opacity-50" />
    </details>
    <p className="text-xs leading-relaxed text-krit-muted">{t('submitNote')}</p>
  </form>;
}
